import { TranslateService } from "@ngx-translate/core";

import { inject } from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";

import { subscriptionNameKey } from "../helpers/subscription-i18n";

export type TitleFn = (a: ActivatedRouteSnapshot, r: RouterStateSnapshot) => Promise<string>;

export const translateTitleResolver = async (titleKey: string): Promise<string> => {
  const translate = inject(TranslateService);
  const title = await translate.get(titleKey).toPromise();
  return processTitle(title);
};

export const servicesListPageTitleResolver: TitleFn = (route: ActivatedRouteSnapshot) => {
  const translate = inject(TranslateService);
  const productType = route.paramMap.get("productType") || route.data.productType;
  return translateServicesListPageTitle(translate, productType);
};

export async function translateServicesListPageTitle(
  translate: TranslateService,
  productType: string,
): Promise<string> {
  const serviceKey = subscriptionNameKey(productType);
  const title = await translate.get(serviceKey ?? "Navigation.Subscriptions").toPromise();
  return processTitle(title);
}

export function processTitle(title: string | undefined): string {
  const app = "Netwerk Dashboard";
  return title ? `${title} | ${app}` : app;
}
